import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

export interface DocumentReturn {
  documentName: string;
  documentAuthor?: string;
}

@Component({
  selector: 'app-modal-select-file',
  templateUrl: './modal-select-file.component.html',
  styleUrls: [
    './modal-select-file.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ModalSelectFileComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public documentName: string;
  public documentAuthor: string;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      documentName: [this.documentName, Validators.required],
      documentAuthor: [this.documentAuthor]
    });
  }

  public validForm(): void {
    const documentInfos: DocumentReturn = {
      documentName: this.formGroup.get('documentName').value,
      documentAuthor: this.formGroup.get('documentAuthor').value ? this.formGroup.get('documentAuthor').value : undefined
    };

    this.closeModal(documentInfos);
  }

  public closeModal(documentInfos?: DocumentReturn): void {
    this.closeEmitter.emit(documentInfos);
  }

}
